import NewsletterList from "../components/NewsletterList";

const ListNewsletterPage = () => {
  return (
    <NewsletterList />
  );
};

export default ListNewsletterPage;
